// SVG path stand-ins for `google.maps.SymbolPath`, for marker `icon.path`.
//
// WHY NOT `window.google.maps.SymbolPath`. Map pages build their marker icons
// in their own render, which runs BEFORE `ui/core/Map`'s `useJsApiLoader`
// resolves. `@googlemaps/js-api-loader` (>= 1.16) installs a bootstrap stub —
// `window.google.maps = { importLibrary }` — synchronously, long before the API
// itself loads, so during that window:
//
//   - `window.google.maps.SymbolPath.CIRCLE` THROWS ("Cannot read properties of
//     undefined (reading 'CIRCLE')"). This is what took TripLocationHistory
//     down on prod: its `window.google && window.google.maps` guard passed on
//     the stub.
//   - `window.google?.maps?.SymbolPath?.CIRCLE` is `undefined`, which Google
//     silently treats as "no icon given" and draws its default red teardrop.
//     Only `Map` re-renders when the API finishes loading — the page that built
//     the icons does not — so the wrong pins stay until something else happens
//     to re-render the page.
//
// A path literal has no load order to get wrong. StationBuilder's
// `EXISTING_STATION_ICON` and LanePolylineEditor's `WAYPOINT_ICON` document the
// same failure in more detail.

// Radius 1 about the origin — the same geometry as `SymbolPath.CIRCLE`, so an
// icon's `scale` keeps meaning "radius in pixels" and existing values carry
// over unchanged.
export const CIRCLE_SYMBOL_PATH = 'M -1,0 A 1,1 0 1,0 1,0 A 1,1 0 1,0 -1,0 Z';
